<template>
  <div class="partner-page">
    <div class="banner-sec">
      <div class="banner banner-solution">
        <div class="wd1">
          <h2 class="banner-title-main">服务行业</h2>
        </div>
      </div>
    </div>
    <div class="cp-one partner-content">
      <div class="wd">
        <ul class="cp-fg-ul partner-ul clearfix">
          <li class="oneOfBox fe-li">
            <div class="service-icon">
              <i class="fa fa-university"></i>
            </div>
            <h4>法院</h4>
            <p>各地区人民法院</p>
          </li>
          <li class="oneOfBox fe-li">
            <div class="service-icon">
              <i class="fa fa-jpy"></i>
            </div>
            <h4>金融</h4>
            <p>银行、保险、汽车金融、消费金融、融资租赁、保理等</p>
          </li>
          <li class="oneOfBox fe-li">
            <div class="service-icon">
              <i class="fa fa-cogs"></i>
            </div>
            <h4>非金融</h4>
            <p>电商、租房、租车、物流等</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Partner',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.partner-page .partner-content {
  padding: 40px 0 60px;
}

.partner-page .partner-ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.partner-page .partner-ul .fe-li {
  float: none;
  width: 30%;
  min-width: 260px;
  margin-left: 0;
  margin-bottom: 24px;
  min-height: 240px;
  padding: 28px 20px 24px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.partner-page .partner-ul .fe-li:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 24px rgba(57, 200, 226, 0.2);
  border-color: #39c8e2;
}

.partner-page .partner-ul .service-icon {
  width: 88px;
  height: 88px;
  line-height: 88px;
  font-size: 28px;
  margin: 0 auto 20px;
}

.partner-page .partner-ul .service-icon i {
  line-height: 88px;
}

.partner-page .partner-ul .fe-li h4 {
  font-size: 20px;
  margin: 0 0 12px;
  color: #333;
}

.partner-page .partner-ul .fe-li p {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
  margin: 0;
  text-align: center;
}

@media (max-width: 900px) {
  .partner-page .partner-ul .fe-li {
    width: 48%;
    min-width: 0;
  }
}

@media (max-width: 600px) {
  .partner-page .partner-ul {
    width: 94%;
    justify-content: center;
  }

  .partner-page .partner-ul .fe-li {
    width: 100%;
    min-width: 0;
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Partner.vue